import Model, { AsyncBelongsTo, belongsTo } from '@ember-data/model';

import type GenreModel from 'admin-panel/models/genre';
import type RoomControlTvChannelModel from 'admin-panel/models/room-control/tv-channel';

export default class RoomControlTvChannelGenreModel extends Model {
  @belongsTo('genre')
  declare genre: AsyncBelongsTo<GenreModel>;

  @belongsTo('room-control/tv-channel')
  declare roomControlTvChannel: AsyncBelongsTo<RoomControlTvChannelModel>;
}

declare module 'ember-data/types/registries/model' {
  export default interface ModelRegistry {
    'room-control/tv-channel-genre': RoomControlTvChannelGenreModel;
  }
}
